import _includes from "lodash/includes";
import _partial from "lodash/partial";
import ExternalLogger from "../logger/ExternalLogger";

//MR: The original accountDetailsController is now accountOverviewController.
//This is now an intermediate parent controller.

var AccountDetailsController = function (
    $controller,
    $q,
    $rootScope,
    $scope,
    $state,
    $window,
    AccuCodeService,
    MenuService,
    LegacyService,
    PreventNavigationService,
    SamlSsoService,
    accountService,
    lockheedModalService,
    personalMessagingService,
    transactionMessagesService
) {
    var logger = ExternalLogger.getInstance("AccountDetailsController");

    // ViewModel replaces $scope where possible
    var vm = this;
    var nonSubMenuGroups = MenuService.nonSubMenuGroups;

    var HeaderController = $controller("HeaderController as HeaderController", {
        $scope: $scope
    });

    //---- commented out --- accountService.setActiveGroupAccount();

    vm.getMenuNavigation = MenuService.getMenuNavigation;
    vm.getActiveMenuItem = MenuService.getActiveMenuItem;
    vm.getActiveSubMenuItem = MenuService.getActiveSubMenuItem;
    vm.setActiveSubMenuItem = MenuService.setActiveSubMenuItem;
    vm.setActiveMenuItem = MenuService.setActiveMenuItem;
    vm.getDetailTitle = MenuService.getDetailTitle;
    vm.isAccountSelected = accountService.isAccountSelected;
    vm.allAccounts = accountService.getAccounts();
    vm.getLegacySiteBaseUrl = LegacyService.getLegacySiteBaseUrl();
    vm.legacyActiveGroupAccount = LegacyService.getLegacyActiveGroupAccount();
    vm.getAccountDetailsLoaded = MenuService.getAccountDetailsLoaded;
    vm.accountDropdownMenuClick = HeaderController.accountDropdownMenuClick;
    vm.currentAccount = null;
    vm.pageTitle = null;
    vm.showSSOError = null;
    vm.ssoDataLoaded = false;
    vm.showSubMenu = function () {
        var activeMenuItem = vm.getActiveMenuItem();
        return (
            activeMenuItem &&
            activeMenuItem.parentItems.length > 0 &&
            nonSubMenuGroups.indexOf(MenuService.getUniqueMenuTitle(activeMenuItem)) === -1
        );
    };

    vm.getPageTitle = function () {
        var activeMenuItem = vm.getActiveMenuItem();
        if (activeMenuItem) {
            var uniqueMenuTitle = MenuService.getUniqueMenuTitle(activeMenuItem);
            if (nonSubMenuGroups.indexOf(uniqueMenuTitle) > -1) {
                return null;
            } else {
                return activeMenuItem.displayText;
            }
        } else {
            return null;
        }
    };

    vm.showSubTitle = function () {
        let showSubTitle = false;

        if (vm.currentAccount) {
            showSubTitle =
                vm.currentAccount.showNqLinkInd === "Y" &&
                vm.currentAccount.nqEligibleToEnrollInd === "Y";
        }

        return showSubTitle;
    };

    vm.getPageSubTitle = function () {
        let subTitle = "";
        let sharedData = window.integratedSharedData;

        if (sharedData) {
            subTitle = sharedData.translations.get("nonqual").landing.nqEnrollmentMessage;
        }

        return subTitle;
    };

    vm.getEnrollText = function () {
        let sharedData = window.integratedSharedData;

        return sharedData ? sharedData.translations.get("accountList").enrollMessage : "";
    };

    /**
     * function to determine if the menu navigation should be displayed.
     */
    vm.showMenuNavigation = function () {
        if ($rootScope.iframe) {
            return false;
        }
        return true;
    };

    vm.isShowTitle = function () {
        var hideTitleForStates = [
            "accountDetails.dividendElectionConfirmation",
            "accountDetails.upload",
            "accountDetails.investments.allocations.nextGenAdviceEnrollmentMarketing",
            "accountDetails.statementsDocuments",
            "accountDetails.statementsOnDemand",
            "accountDetails.loan.request",
            "accountDetails.withdrawal.request"
        ];

        return vm.getPageTitle() !== null && !_includes(hideTitleForStates, $state.current.name);
    };

    vm.isNextGen = function () {
        return (
            $state.current.name.indexOf("iframe") === -1 &&
            $state.current.name.indexOf("subMenu") === -1
        );
    };

    vm.getUrlForNavItem = MenuService.getUrlForNavItem;

    $rootScope.$on("currentAccountUpdated", function () {
        console.log("currentAccountUpdated -");
        vm.currentAccount = accountService.currentAccount;
        $window.location.reload();
    });

    $rootScope.$on("cancelSwitchPlan", function () {
        const currentUrl = $window.location.href;
        const onAccountDetailsPage = currentUrl.indexOf("account-details") >= 0;
        if (onAccountDetailsPage) {
            const current = accountService.getCurrentAccount();
            vm.changeAccount(current);
        }
    });

    window.addEventListener(
        "cancelSwitchPlan",
        function (e) {
            const currentUrl = $window.location.href;
            const onAccountDetailsPage = currentUrl.indexOf("account-details") >= 0;
            if (onAccountDetailsPage) {
                const current = accountService.getCurrentAccount();
                vm.changeAccount(current);
            }
        },
        false
    );

    vm.changeAccount = function (currentAccount) {
        if (PreventNavigationService.isPreventUrl()) {
            $scope.changeAccount = vm.changeAccount;
            $scope.currentAccount = currentAccount;
            PreventNavigationService.preventNavigation(null, "CHANGEACCOUNT", $scope);
        } else {
            vm.currentAccount = currentAccount;
            if (!currentAccount.currentContext) {
                accountService.switchPlan(currentAccount, true);
            } else {
                var currentGroupAccount = {
                    individualId: currentAccount.individualId,
                    groupId: currentAccount.groupId
                };

                setChatVariables(vm.currentAccount);
                setPersonalMessagingData(vm.currentAccount);
                accountService.setActiveGroupAccount(currentGroupAccount).then(function () {
                    LegacyService.performLegacySSO(currentGroupAccount);
                });
                accountService.setSiteContactInfoForPlan(currentAccount);
                //MR: What is this accountDetailState? May be deprecated or unused, the other cases are valid (12/16/15)
                if (currentAccount.accountDetailState) {
                    $state.go(currentAccount.accountDetailState, currentAccount, currentAccount, {
                        reload: true
                    });
                } else if (currentAccount.definedBenefitPlan) {
                    $state.go("accountDetails.accountOverviewDB", currentAccount, { reload: true });
                } else if (currentAccount.hsaPlan) {
                    $state.go("accountDetails.accountOverviewHSA", currentAccount, {
                        reload: true
                    });
                } else if (
                    currentAccount.groupDetails &&
                    currentAccount.groupDetails.irsrlCode === "TRS"
                ) {
                    $state.go("accountDetails.accountOverviewTRS", currentAccount, {
                        reload: true
                    });
                } else {
                    $state.go("accountDetails.accountOverview", currentAccount, { reload: true });
                }
            }
        }
    };

    /**
     * Initializes iframe for legacy views.
     * MR: Included here so that it can be called right after the active menu item is reset.
     */

    vm.initIframeView = function () {
        var menuItem = MenuService.getActiveSubMenuItem()
            ? MenuService.getActiveSubMenuItem()
            : MenuService.getActiveMenuItem();
        if (
            LegacyService.isLegacy(MenuService.getActiveSubMenuItem()) ||
            LegacyService.isLegacy(MenuService.getActiveMenuItem())
        ) {
            LegacyService.initIframeView(menuItem, vm.activeGroupAccount, $state.params);
        }
    };

    /**
     * Initialization for each account details view.
     */
    vm.initAccountDetailsView = function (needToChangeActiveMenuItem) {
        var method = "initAccountDetailsView()";
        var deferred = $q.defer();
        //var resolveAccount = $q.defer();
        //Set account, load details and menu navigation when choosing new account
        //or switching between accounts.
        logger.debug("{0}- Enter method. needToChangeActiveMenuItem = {1}", [
            method,
            needToChangeActiveMenuItem
        ]);
        MenuService.setAccountDetailsLoaded(false);
        if (!vm.allAccounts.length) {
            logger.debug("{0}- allAccounts array not set. Calling accountService.setAccounts()", [
                method
            ]);
            accountService.setAccounts().then(function () {
                logger.debug("{0}- got allAccounts.", [method]);
                vm.allAccounts = accountService.getAccounts();
                vm.allAccounts = accountService.concatenatedPlans(vm.allAccounts);
                vm.activeGroupAccount = accountService.getActiveGroupAccount();
                vm.currentAccount = vm.allAccounts.filter(function (account) {
                    return (
                        account.individualId === vm.activeGroupAccount.individualId &&
                        account.groupId === vm.activeGroupAccount.groupId
                    );
                })[0];
            });
        } else {
            vm.allAccounts = accountService.concatenatedPlans(vm.allAccounts);
        }

        logger.debug("{0}- Calling accountService.setActiveGroupAccount()..", [method]);
        accountService
            .setActiveGroupAccount()
            .then(function () {
                vm.activeGroupAccount = accountService.getActiveGroupAccount();
                logger.debug(
                    "{0}-   Got activeGroupAcct. gaId={1}. Now calling setAccountDetails() ...",
                    [method, accountService.getActiveGroupAccount().groupId]
                );
                return accountService.setAccountDetails();
            })
            .then(function () {
                logger.debug(
                    "{0}-  Got accountDetails back. activeGroupAccount gaId={1}. Now calling retrieveMenuNavDetails() ... ",
                    [method, accountService.getActiveGroupAccount().groupId]
                );
                /*return _partial(MenuService.retrieveMenuNavDetails,
        				accountService.getActiveGroupAccount().groupId, needToChangeActiveMenuItem);
        		*/
                return MenuService.retrieveMenuNavDetails(
                    accountService.getActiveGroupAccount().groupId,
                    needToChangeActiveMenuItem
                );
            })
            .then(function () {
                logger.debug("{0}-  Got MenuNavDetails", [method]);
                if (!vm.isNextGen()) {
                    logger.debug(
                        "{0}-  Plan is not NextGen. call LegacyService.performLegacySSO() ",
                        [method]
                    );
                    LegacyService.performLegacySSO(accountService.getActiveGroupAccount()).then(
                        function () {
                            logger.debug(
                                "{0}-  after performLegacySSO(). Calling initIframeView() and resolve. ",
                                [method]
                            );
                            vm.initIframeView();
                            deferred.resolve();
                        }
                    );
                } else {
                    logger.debug("{0}- Resolve", [method]);
                    deferred.resolve();
                }
            });
        return deferred.promise;
    };

    /**
     * returns the primary account details content wrapper div class
     */
    vm.getContainerClass = function () {
        var classes =
            "col-sm-12 col-md-9 col-lg-9 account-detail-main-content-wrapper inner-container";
        if ($rootScope.isNextGenIframe !== true) {
            classes += " with-shadow with-padding";
        }

        return classes;
    };

    /**
     * Sets the class for the body columns. If the transactional message is showing then make the body smaller.
     * @return {String}
     */
    vm.getBodyColumnClass = function () {
        var small = "col-sm-12 col-md-9 col-lg-9";
        var large = "col-sm-12 col-md-12 col-lg-12";

        return transactionMessagesService.showMessagesColumn() &&
            transactionMessagesService.getTransactionMessageLayoutPosition() == "right"
            ? small
            : large;
    };

    vm.goToNQEnrollment = function (groupId) {
        var method = "acccount details ctlr - goToNQEnrollment";
        logger.debug("{0} - groupId=[{1}]", [method, groupId]);

        lockheedModalService.isPlanLockheedNonQual(groupId).then(function (isGroupLockheedPlan) {
            if (isGroupLockheedPlan) {
                lockheedModalService.loadTermsOfServiceModal(groupId);
            } else {
                $state.go("nqEnrollmentSummary", { groupId: groupId });
            }
        });
    };

    var postInit = function () {
        var method = "postInit()";
        logger.debug("{0}- in method.", [method]);
        vm.pageTitle = vm.getPageTitle();
        setChatVariables(vm.activeGroupAccount);
        setPersonalMessagingData(vm.activeGroupAccount);
        vm.currentAccount = vm.allAccounts.filter(function (account) {
            return (
                account.individualId === vm.activeGroupAccount.individualId &&
                account.groupId === vm.activeGroupAccount.groupId
            );
        })[0];

        var activeGroupAccountGroupId = accountService.getActiveGroupAccount().groupId;
        var activeGroupAccountIndividualId = accountService.getActiveGroupAccount().individualId;

        if (
            activeGroupAccountGroupId &&
            activeGroupAccountIndividualId !== "undefined" &&
            activeGroupAccountGroupId &&
            activeGroupAccountIndividualId !== null
        ) {
            SamlSsoService.showSamlSso(
                "WNRPSO",
                activeGroupAccountGroupId,
                activeGroupAccountIndividualId
            ).then(function (value) {
                vm.ssoDataLoaded = true;
                if (value === true) {
                    vm.showSSOError = true;
                }
            });
        }

        logger.debug("{0}- Done with postInit. vm.CurrentAccount: indId={1}, gaId={2}", [
            method,
            vm.currentAccount ? vm.currentAccount.individualId : "",
            vm.currentAccount ? vm.currentAccount.groupId : ""
        ]);
        MenuService.setAccountDetailsLoaded(true);
    };

    //------ main ----------
    vm.initAccountDetailsView().then(postInit);

    //-----------------

    $rootScope.$on("$stateChangeSuccess", function (e, toState, toParams, fromState, fromParams) {
        var needToChange = needToChangeActiveMenuItem(toState, toParams, fromState, fromParams);
        logger.debug(
            "$stateChangeSuccess( " +
                "needToChange = {0}, fromState.name = {1}, fromParams.groupId = {2}, " +
                "toState.name = {3}, toParams.groupId = {4} )",
            [
                String(needToChange),
                fromState.name,
                fromParams.groupId,
                toState.name,
                toParams.groupId
            ]
        );
        if (needToChange) {
            MenuService.setAccountDetailsLoaded(false);
            logger.debug("$stateChangeSuccess( Calling initAccountDetailsView() )");
            vm.initAccountDetailsView(needToChange).then(function () {
                logger.debug("$stateChangeSuccess( Calling postInit() )");
                postInit();
            });
        }
    });

    /**
     * Need to change active menu item:
     * Checks whether the user is navigating from one account details page to another, and if so if the active menu item
     * needs to be updated. We need to check this because ui-router does not reload this controller when navigating between
     * two account detail sibling states, and not doing this leads to menu titles not changing, sub menus persisting, etc.
     **/
    function needToChangeActiveMenuItem(toState, toParams, fromState, fromParams) {
        return (
            (toState.name.indexOf("accountDetails") > -1 &&
                fromState.name.indexOf("accountDetails") > -1 &&
                (toParams.menuItem !== fromParams.menuItem ||
                    (toParams.subMenuItem && fromParams.subMenuItem !== toParams.subMenuItem))) ||
            (!toParams.menuItem && toState.name !== fromState.name) ||
            toParams.individualId !== fromParams.individualId ||
            toParams.groupId !== fromParams.groupId
        );
    }

    function setChatVariables(activeGroupAccount) {
        if (!$rootScope.chatParticipantData) {
            $rootScope.chatParticipantData = {
                unit: "",
                language: "",
                participantIdNumber: "",
                participantName: "",
                planName: "",
                planNumber: ""
            };
        }
        $rootScope.chatParticipantData.participantIdNumber = activeGroupAccount.individualId;
        $rootScope.chatParticipantData.planNumber = activeGroupAccount.groupId;

        accountService.getChatAccountDetails($rootScope.chatParticipantData);
    }

    function setPersonalMessagingData(activeGroupAccount) {
        if (!$rootScope.personalMessagingData) {
            $rootScope.personalMessagingData = {
                planNumber: "",
                accu: ""
            };
        }

        $rootScope.personalMessagingData.planNumber = activeGroupAccount.groupId;
        $rootScope.personalMessagingData.accu = AccuCodeService.getAccuCode();

        personalMessagingService.updatePMCookies(activeGroupAccount, accu);
    }

    $scope.prevent = function (e, type) {
        var originalEvent = e.originalEvent;
        var currentEventInnerText = originalEvent.explicitOriginalTarget
            ? originalEvent.explicitOriginalTarget.innerText
            : originalEvent.target.innerText;
        var lastChildInnerText = e.currentTarget.lastElementChild.firstElementChild.innerText;
        if (currentEventInnerText !== lastChildInnerText) {
            if (PreventNavigationService.isPreventUrl()) {
                PreventNavigationService.preventNavigation(e, type, $scope);
            } else {
                // work-around for mobile view; state not redirecting breadcrumb routing
                if (String(currentEventInnerText).toLowerCase() === "home") {
                    $state.go("landing");
                }
            }
        }
    };
};

AccountDetailsController.$inject = [
    "$controller",
    "$q",
    "$rootScope",
    "$scope",
    "$state",
    "$window",
    "AccuCodeService",
    "MenuService",
    "LegacyService",
    "PreventNavigationService",
    "SamlSsoService",
    "accountService",
    "lockheedModalService",
    "personalMessagingService",
    "transactionMessagesService"
];
export default AccountDetailsController;
